import React, { useMemo, useState } from "react";
import type { Route } from "nextjs-routes";
import useRouter from "domains/navigation/hooks/useRouter";
import { useTeamContext } from "domains/teams/contexts/TeamProvider";
import Button from "domains/ui/components/Button";
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
} from "domains/ui/components/Modal";

import { HStack, Image, Skeleton, Text, VStack } from "@chakra-ui/react";

export default function ReaderModal() {
  const { isReader } = useTeamContext();
  const router = useRouter();
  const [isVideoLoading, setIsVideoLoading] = useState(true);

  const isOnRestrictedPage = useMemo(() => {
    const restrictedPages: Route["pathname"][] = [
      "/background-remove",
      "/canvas/[id]",
      "/canvas/new",
      "/compose/new",
      "/enhance",
      "/expand",
      "/images/new",
      "/models/new/[id]",
      "/models/new",
      "/pixelate",
      "/restyle",
      "/skyboxes/enhance",
      "/skyboxes/new",
      "/textures/enhance",
      "/textures/new",
      "/vectorize",
    ];
    return restrictedPages.includes(router.pathname);
  }, [router.pathname]);

  return (
    <Modal
      isOpen={isOnRestrictedPage && isReader}
      onClose={() => {}}
      variant="modern"
    >
      <ModalOverlay />
      <ModalContent p={0} w="700px" maxW="90vw">
        <ModalBody w="full">
          <HStack gap={0}>
            <VStack
              pos="relative"
              align="end"
              justify="space-between"
              gap="100px"
              w="60%"
              px={8}
              py={10}
            >
              <VStack align="stretch" gap={4}>
                <Image
                  w="30px"
                  minW="30px"
                  alt="logo"
                  src="/logos/scenario.svg"
                />
                <VStack align="start" gap={2} textAlign="start">
                  <Text size="title.sm">
                    Ask your Admin to Grant You Access
                  </Text>
                  <Text color="textSecondary" size="body.md">
                    This feature is not available with the reader role.
                  </Text>
                </VStack>
              </VStack>
              <Button variant="secondary" onClick={() => router.back()}>
                Go back
              </Button>
            </VStack>
            <video
              src="https://cdn.cloud.scenario.com/static/landing-page/homepage/take-full-control.mp4"
              autoPlay
              muted
              loop
              style={{
                height: "100%",
                width: "40%",
                objectFit: "cover",
                position: "absolute",
                top: 0,
                right: 0,
                borderLeftWidth: "1px",
                borderColor: "var(--chakra-colors-border-500)",
              }}
              onLoadedData={() => setIsVideoLoading(false)}
            />
            {isVideoLoading && (
              <Skeleton
                pos="absolute"
                top={0}
                right={0}
                w="40%"
                h="100%"
                borderColor="border.500"
                borderLeftWidth="1px"
              />
            )}
          </HStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
